import { useState } from "react";
import { Loader2, Save, X } from "lucide-react";

export default function DecodeEditor({ draft, onClose, onSave }) {
  const [title, setTitle] = useState(draft.title || "");
  const [body, setBody] = useState(draft.body || "");
  const [tagsStr, setTagsStr] = useState((draft.tags || []).join(", "));
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    setBusy(true);
    await onSave({
      id: draft.id,
      title,
      body,
      tags: tagsStr.split(",").map((t) => t.trim()).filter(Boolean),
      author: draft.author || "Gem Key",
    });
    setBusy(false);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-start justify-center p-4 md:p-8 overflow-auto" style={{ background: "rgba(0,0,0,0.7)" }}>
      <div className="panel w-full max-w-3xl p-6 md:p-8 space-y-5" data-testid="decode-editor">
        <div className="flex justify-between items-center">
          <div className="font-mono text-[10px] uppercase tracking-[0.22em] muted">
            {draft.id ? "// Edit decode" : "// New decode"}
          </div>
          <button onClick={onClose} className="muted hover:text-white" data-testid="decode-editor-close">
            <X size={18} />
          </button>
        </div>
        <input
          autoFocus
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          placeholder="Decode title…"
          className="terminal-input w-full px-4 py-3 font-display text-2xl"
          data-testid="decode-title-input"
        />
        <textarea
          value={body}
          onChange={(e) => setBody(e.target.value)}
          placeholder="Paste or write your decode here. Numbers will auto-highlight in gold."
          rows={16}
          className="terminal-input w-full px-4 py-3 text-sm font-mono leading-relaxed resize-y"
          data-testid="decode-body-input"
        />
        <input
          value={tagsStr}
          onChange={(e) => setTagsStr(e.target.value)}
          placeholder="tags, comma, separated (e.g. eclipse, rothschild, jesuit)"
          className="terminal-input w-full px-4 py-2 text-sm font-mono"
          data-testid="decode-tags-input"
        />
        <div className="flex justify-end gap-3">
          <button onClick={onClose} className="btn-secondary px-4 py-2 text-xs">Cancel</button>
          <button
            onClick={submit}
            disabled={busy || !title.trim() || !body.trim()}
            className="btn-primary px-5 py-2 text-xs flex items-center gap-2 disabled:opacity-50"
            data-testid="decode-save"
          >
            {busy ? <Loader2 className="animate-spin" size={14} /> : <Save size={14} />}
            {draft.id ? "Update" : "Publish"}
          </button>
        </div>
      </div>
    </div>
  );
}
